import { DEFAULT_LOCALE } from '@constants';

import api from '..';
import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

export const useBooksList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'books', api: api.books }, queryVariables, queryConfig);

  return {
    books: queryResult.resolvedData,
    latestBooks: queryResult.latestData,
    ...queryResult,
  };
};

export const useBooksByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['books', { ids }], api.books.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    books: queryResult.data || [],
    ...queryResult,
  };
};

export const useBook = ({ id, locale = DEFAULT_LOCALE }, queryConfig = {}) => {
  const queryResult = useQuery(['book', { id, locale }], api.books.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    book: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'books' });

export const useDeleteBook = createMutation(api.books.remove);

export const useCreateBook = createMutation(api.books.create);

export const useUpdateBook = createMutation(api.books.update);

export const usePublishBook = createMutation(api.books.publish);

export const useUnpublishBook = createMutation(api.books.unpublish);

export const useDuplicateBook = createMutation(api.books.duplicate);
